import { Button, Typography } from "@mui/material";
import React from "react";
import UpRightIcon from "../../icons/UpRightIcon";

interface IconButtonProps {
  label: string;
  onClick?: () => void;
  enableIcon?: boolean;
}
const IconButton = (props: IconButtonProps) => {
  const { label, onClick, enableIcon = true } = props;
  const handleClick = () => {
    if (enableIcon) {
      onClick();
      return;
    } else {
      return;
    }
  };
  return (
    <Button
      sx={{
        border: "1px solid gray",
        borderRadius: "16px",
        bgcolor: "#F9F9F9",
        display: "flex",
        alignItems: "center",
        columnGap: 1,
        width: "fit-content",
      }}
      onClick={handleClick}
    >
      <Typography
        color={"#414040"}
        variant="body2"
        sx={{
          fontStyle: "italic",
          fontWeight: 500,
        }}
      >
        {label}
      </Typography>
      {enableIcon && <UpRightIcon size="xxs" color="primary" />}
    </Button>
  );
};

export default IconButton;
